import React, { useCallback, useEffect, useRef, useState } from 'react';
import { createImageMarker } from 'app/core/markers/models';
import { ProjectActions } from 'app/stores/project/actions';
import { getPageRect } from 'app/stores/project/page';
import { getCurrentPage, getInsertStyle, getPageImage, } from 'app/stores/selectors';
import { useAppDispatch, } from 'app/stores/store';
import { FilePickerBase } from 'app/views/components/empty/FilePickerBase';
import { addDocumentListener } from 'app/utils/events';
import { call, noop } from 'app/utils/function';
import { scaleInAspect } from 'app/utils/math';
export const createImageMarkerFromState = (point, state) => {
    var _a, _b;
    const slide = getCurrentPage(state);
    if (!slide) {
        return undefined;
    }
    const image = getPageImage(state, slide.id);
    const slideSize = getPageRect(slide, image);
    const markerInitialSize = scaleInAspect(slideSize, {
        width: Math.max(100, slideSize.width * 0.1),
        height: Math.max(100, slideSize.height * 0.1),
    });
    const marker = createImageMarker({
        x: point.x,
        y: point.y,
        endX: markerInitialSize.width,
        endY: markerInitialSize.height,
    });
    const style = getInsertStyle(state);
    const { size, color, sizeFactor } = style;
    const markerSize = (_a = marker.size) !== null && _a !== void 0 ? _a : size;
    marker.size = markerSize / sizeFactor;
    const markerColor = (_b = marker.color) !== null && _b !== void 0 ? _b : color;
    marker.color = markerColor;
    return marker;
};
export const InsertImage = () => (dispatch, getState) => {
    const state = getState();
    const onDragStart = (payload, point) => {
        const marker = createImageMarkerFromState(point, state);
        payload.itemId = marker.id;
        dispatch(ProjectActions.itemInsert({
            marker,
            undoable: true,
        }));
        document.dispatchEvent(new CustomEvent('insertImageOpenPicker', {
            detail: { markerId: marker.id },
        }));
    };
    const onDrag = (payload, point) => {
        const { itemId: id } = payload;
        if (id) {
            dispatch(ProjectActions.itemUpdate({
                id,
                patch: {
                    x: point.x,
                    y: point.y,
                },
                undoable: false,
            }));
        }
    };
    return {
        onPointerDown: onDragStart,
        onPointerDrag: onDrag,
        onPointerUp: noop,
    };
};
export const InsertImageComponent = () => {
    const appDispatch = useAppDispatch();
    const opener = useRef(undefined);
    const [markerId, setMarkerId] = useState(undefined);
    const onSelect = useCallback((files) => {
        const file = files === null || files === void 0 ? void 0 : files[0];
        if (file && markerId) {
            appDispatch(ProjectActions.createMarkerFromImageData({
                markerId,
                data: file,
                source: 'file',
            }));
        }
    }, [markerId, appDispatch]);
    useEffect(() => {
        const handler = (event) => {
            var _a;
            const mid = (_a = event.detail) === null || _a === void 0 ? void 0 : _a.markerId;
            if (mid) {
                call(opener.current);
                setMarkerId(mid);
            }
        };
        return addDocumentListener('insertImageOpenPicker', handler);
    }, [opener, setMarkerId]);
    return (React.createElement(FilePickerBase, { maxFiles: 1, onSelect: onSelect }, open => {
        opener.current = open;
        return null;
    }));
};
